import { Select } from './Select';

type PaginationControlsProps = {
  summaryText: string;
  pageSize: number;
  onPageSizeChange: (size: number) => void;
  onPrev: () => void;
  onNext: () => void;
  disablePrev: boolean;
  disableNext: boolean;
  prevLabel: string;
  nextLabel: string;
  getPageSizeLabel: (size: number) => string;
  pageSizeOptions?: readonly number[];
  disabled?: boolean;
  hideSummary?: boolean;
};

const DEFAULT_PAGE_SIZE_OPTIONS = [10, 20, 50] as const;

export const PaginationControls = ({
  summaryText,
  pageSize,
  onPageSizeChange,
  onPrev,
  onNext,
  disablePrev,
  disableNext,
  prevLabel,
  nextLabel,
  getPageSizeLabel,
  pageSizeOptions = DEFAULT_PAGE_SIZE_OPTIONS,
  disabled = false,
  hideSummary = false,
}: PaginationControlsProps) => {
  return (
    <div
      data-pagination-controls
      className={`flex flex-col gap-2 px-4 py-3 sm:flex-row sm:items-center ${hideSummary ? 'sm:justify-end' : 'sm:justify-between'}`}
    >
      {hideSummary ? null : <p className="text-xs text-[var(--color-fg-subtle)]">{summaryText}</p>}
      <div className="flex items-center gap-2">
        <Select
          size="xs"
          value={String(pageSize)}
          onChange={(val) => onPageSizeChange(Number(val))}
          disabled={disabled}
          options={pageSizeOptions.map((size) => ({ value: String(size), label: getPageSizeLabel(size) }))}
          optionsPlacement="top"
        />
        <button
          type="button"
          className="btn btn-outline btn-xs disabled:opacity-50"
          onClick={onPrev}
          disabled={disabled || disablePrev}
        >
          {prevLabel}
        </button>
        <button
          type="button"
          className="btn btn-outline btn-xs disabled:opacity-50"
          onClick={onNext}
          disabled={disabled || disableNext}
        >
          {nextLabel}
        </button>
      </div>
    </div>
  );
};
